export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10292.ac8eaa06.jpg";